import React, { useState, createContext, useContext, useMemo, useCallback } from 'react';


const initialState = {
    run: false,
    stepIndex: 0,
    steps: [],
    currentTour: null,
    tourActive: false
};


export const JoyrideContext = createContext({
    state: initialState,
    setState: () => undefined,
    startTour: () => undefined,
    endTour: () => undefined,
    nextStep: () => undefined,
    prevStep: () => undefined,
});

JoyrideContext.displayName = 'JoyrideContext';

export function JoyrideProvider({ children }) {
    const [state, setState] = useState(initialState);

    const startTour = useCallback((currentTour) => {
        setState(prevState => ({
            ...prevState,
            currentTour: currentTour || null,
            run: true,
            tourActive: true,
            stepIndex: 0
        }));
    }, []);

    const endTour = useCallback(() => {
        setState(prevState => ({
            ...prevState,
            currentTour: null,
            run: false,
            tourActive: false,
        }));
    }, []);

    const nextStep = useCallback(() => {
        setState(prevState => ({
            ...prevState,
            stepIndex: prevState.stepIndex + 1
        }));
    }, []);

    const prevStep = useCallback(() => {
        setState(prevState => ({
            ...prevState,
            stepIndex: Math.max(0, prevState.stepIndex - 1)
        }));
    }, []);

    const value = useMemo(
        () => ({
            state,
            setState,
            startTour,
            endTour,
            nextStep,
            prevStep,
        }),
        [state, setState, startTour, endTour, nextStep, prevStep],
    );

    return <JoyrideContext.Provider value={value}>{children}</JoyrideContext.Provider>;
}

export function useJoyrideContext() {
    const context = useContext(JoyrideContext);

    if (!context) {
        throw new Error('useJoyrideContext must be used within a JoyrideProvider');
    }

    return context;
}

